/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const CLOUD_WASTE_DESCRIPTION =
  "In IBM Multicloud Accelerator, every Estate Record that matches these settings is treated as a Savings Suggestion that you can take action on.";

export const SUCCESS_MESSAGE = "Settings have been saved";
export const ERROR_MESSAGE = "There was an error while saving the settings";

export const SAVINGS_SUGGESTIONS_INFO =
  "Your Savings Suggestions Settings changes will be applied on every Monday morning";
